(() => {
  const selector = '[data-unik-subscription-submit]';

  function reset(form) {
    form.querySelectorAll(`${selector}[aria-busy="true"]`).forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('submit', event => {
    const form = event.target;
    const button = form.querySelector(selector);
    if (!button) return;
    if (button.disabled) {
      event.preventDefault();
      return;
    }
    if (event.defaultPrevented) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  });

  document.addEventListener('reset', event => reset(event.target));
  window.addEventListener('pageshow', () => reset(document));
})();
